import React, { Component } from "react";
import Axios from "../../../config/axios";
import withErrorHandler from "hoc/withErrorHandler";
import {
  PageHeader,
  Col,
  List,
  Button,
  Row,
  Tooltip,
  Input,
  Tag,
  Modal,
} from "antd";
import { EditOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import openNotificationWithIcon from "helpers/notification";

class LetterCodePage extends Component {
  state = {
    letters: [],
    edit: [],
    editMajor: [],
    prodiModal: false,
    prodiCodes: [],
    selectedLetterId: "",
  };

  componentDidMount() {
    this.fetchLetters();
  }

  showProdiModal = () => this.setState({ prodiModal: true });
  hideProdiModal = () => {
    this.setState({ prodiModal: false, prodiCodes: [], editMajor: [] });
  };

  fetchLetters = async () => {
    const { user } = this.props;
    let unitFaculty = user.user_unit.unit_id;
    let unitMajor = user.info.unit_id;

    if (user.info.type === "admin") {
      const params = new URLSearchParams(this.props.location.search);
      unitFaculty = params.get("unit_id");
      unitMajor = params.get("unit_id");
    }

    const letters = Axios.get(`letters?faculty_id=${unitFaculty}`);
    // const letters = Axios.get(`letters?faculty_id=22`)
    const lettercodes = Axios.get(`lettercode?unit_id=${unitMajor}`);
    // const lettercodesFaculty = Axios.get(`lettercode?unit_id=22`)
    const lettercodesFaculty = Axios.get(`lettercode?unit_id=${unitFaculty}`);
    const response = await Promise.all([
      letters,
      lettercodes,
      lettercodesFaculty,
    ]);
    const result = response[0].data.payload.map((letter) => {
      const code = response[1].data.payload.find(
        (code) => code.letter_id === letter._id
      );
      const codeFaculty = response[2].data.payload.find(
        (code) => code.letter_id === letter._id
      );

      return code
        ? {
            ...code,
            use_letter_number: letter.use_letter_number,
            unit_code:
              letter.letterhead_type === "fakultas"
                ? codeFaculty?.unit_code || "__"
                : code.unit_code || "__",
            letter_type_code:
              letter.letterhead_type === "fakultas"
                ? codeFaculty?.letter_type_code || "__"
                : code.letter_type_code || "__",
          }
        : {
            _id: undefined,
            unit_id: this.props.user.info.unit_id,
            use_letter_number: letter.use_letter_number,
            unit_code:
              letter.letterhead_type === "fakultas"
                ? codeFaculty?.unit_code || "__"
                : "__",
            letter_type_code:
              letter.letterhead_type === "fakultas"
                ? codeFaculty?.letter_type_code || "__"
                : "__",
            letter_name: letter.title,
            letter_type: letter.type,
            letter_id: letter._id,
            letterhead_type: letter.letterhead_type,
          };
    });

    const lettersWithCodes = await Promise.all(result);
    this.setState({ letters: lettersWithCodes });
  };

  handleEdit = (id, letter_id) => {
    let { edit } = this.state;
    const finded = edit.findIndex((ed) => ed.letter_id === letter_id);
    if (finded !== -1) {
      edit.splice(finded, 1);
    } else {
      edit = [...edit, { id, letter_id }];
    }

    this.setState({ edit });
  };

  handleEditMajor = (id, letter_id, index) => {
    let { editMajor } = this.state;
    const finded = editMajor.findIndex((ed) => ed.letter_id === letter_id);
    if (finded !== -1) {
      editMajor.splice(finded, 1);
    } else {
      editMajor = [...editMajor, { id, letter_id, index }];
    }

    this.setState({ editMajor });
  };

  handleChangeNumber = (index, name, val) => {
    let { letters } = this.state;
    letters[index][name] = val;
    this.setState({ letters });
  };

  handleChangeNumberMajor = (index, name, val) => {
    let { prodiCodes } = this.state;
    if (prodiCodes[index].letter_code)
      prodiCodes[index].letter_code[name] = val;
    else
      prodiCodes[index].letter_code = {
        [name]: val,
      };
    this.setState({ prodiCodes });
  };

  handleSave = async (index) => {
    const form = this.state.letters[index];
    if (!form._id) {
      await Axios.post("/lettercode/save", form);
      openNotificationWithIcon(
        "success",
        "Kode Surat",
        "Kode Surat Berhasil Ditambah"
      );
    } else {
      await Axios.put(`/lettercode/save/${form._id}`, form);
      openNotificationWithIcon(
        "success",
        "Kode Surat",
        "Kode Surat Berhasil Diubah"
      );
    }

    let { edit } = this.state;
    edit = edit.filter((ed) => ed.letter_id !== form.letter_id);
    this.setState({ edit });
    this.fetchLetters();
  };

  handleSaveMajor = async (index, letter_id) => {
    const { letter_code, id: unit_id } = this.state.prodiCodes[index];
    const form = {
      ...letter_code,
      unit_id,
      letter_id: this.state.selectedLetterId,
    };
    try {
      if (!form._id) {
        await Axios.post("/lettercode/save", form);
        openNotificationWithIcon(
          "success",
          "Kode Surat",
          "Kode Surat Berhasil Ditambah"
        );
      } else {
        await Axios.put(`/lettercode/save/${form._id}`, form);
        openNotificationWithIcon(
          "success",
          "Kode Surat",
          "Kode Surat Berhasil Diubah"
        );
      }
      this.fetchLetters();
      this.hideProdiModal();
    } catch (err) {
      console.error(err);
    }
  };

  handleShowProdiCode = async (letterId) => {
    const lettercodes = await Axios.get(
      `/lettercode/prodis?unit_id=${this.props.user.info.unit_id}&letter_id=${letterId}`
    );
    this.setState({ prodiCodes: lettercodes.data, selectedLetterId: letterId });

    this.showProdiModal();
  };

  render() {
    return (
      <div
        className="site-layout-background"
        style={{ padding: 10, minHeight: 360 }}
      >
        <PageHeader
          className="site-page-header"
          onBack={() => null}
          backIcon={null}
          title="Kode Surat"
          subTitle="daftar surat"
        />
        <Col>
          <List
            size="large"
            dataSource={this.state.letters}
            renderItem={(item, index) => {
              return (
                <List.Item key={index}>
                  <Row>
                    <Col span={24}>
                      <h4>
                        <strong>{item.letter_name}</strong>
                      </h4>
                    </Col>
                    {this.state.edit.find(
                      (ed) => ed.letter_id === item.letter_id
                    ) ? (
                      <Col>
                        <Row gutter={[8, 8]}>
                          <Col>
                            <span>
                              no_surat/
                              <Input
                                onChange={(e) =>
                                  this.handleChangeNumber(
                                    index,
                                    "unit_code",
                                    e.target.value
                                  )
                                }
                                style={{ width: 80 }}
                                value={item.unit_code}
                              />
                              /
                              <Input
                                onChange={(e) =>
                                  this.handleChangeNumber(
                                    index,
                                    "letter_type_code",
                                    e.target.value
                                  )
                                }
                                style={{ width: 50 }}
                                value={item.letter_type_code}
                              />
                              /tahun
                            </span>
                          </Col>
                          <Col>
                            <Tooltip title="Simpan Kode Surat">
                              <Button
                                type="primary"
                                size="small"
                                icon={<SaveOutlined />}
                                onClick={() => this.handleSave(index)}
                              />
                            </Tooltip>
                          </Col>
                          <Col>
                            <Tooltip title="Batal">
                              <Button
                                type="danger"
                                size="small"
                                icon={<CloseOutlined />}
                                onClick={() =>
                                  this.handleEdit(item._id, item.letter_id)
                                }
                              />
                            </Tooltip>
                          </Col>
                        </Row>
                      </Col>
                    ) : item.use_letter_number ? (
                      <Col>
                        <Row gutter={[8, 8]}>
                          {item.letterhead_type === "fakultas" ||
                          (item.letterhead_type === "prodi" &&
                            this.props.user.info.type === "prodi") ? (
                            <Col>
                              <span>
                                no_surat/<strong>{item.unit_code}</strong>/
                                <strong>{item.letter_type_code}</strong>/tahun
                              </span>
                            </Col>
                          ) : null}

                          {(["operator", "admin"].includes(
                            this.props.user.info.type
                          ) &&
                            item.letterhead_type === "fakultas") ||
                          (item.letterhead_type === "prodi" &&
                            this.props.user.info.type === "prodi") ? (
                            <Col>
                              <Tooltip title="Update Kode Surat">
                                <Button
                                  type="primary"
                                  size="small"
                                  icon={<EditOutlined />}
                                  onClick={() =>
                                    this.handleEdit(item._id, item.letter_id)
                                  }
                                />
                              </Tooltip>
                            </Col>
                          ) : null}
                        </Row>
                      </Col>
                    ) : (
                      <Col>Tidak Menggunakan Kop Surat</Col>
                    )}
                    <Col span={24}>
                      Diproses Oleh:{" "}
                      <Tag>
                        {item.letter_type === "akademik2"
                          ? "PRODI"
                          : "FAKULTAS"}
                      </Tag>
                    </Col>
                    <Col span={24}>
                      Menggunakan Kop dan Surat:{" "}
                      <Tag>{item.letterhead_type.toUpperCase()}</Tag>
                    </Col>
                    {this.props.user.info.type !== "prodi" &&
                    item.letterhead_type === "prodi" &&
                    item.use_letter_number ? (
                      <Button
                        onClick={() => this.handleShowProdiCode(item.letter_id)}
                        style={{ marginTop: 12 }}
                      >
                        Lihat Daftar Kode Surat Prodi
                      </Button>
                    ) : null}
                  </Row>
                </List.Item>
              );
            }}
          />
        </Col>

        <Modal
          visible={this.state.prodiModal}
          title="Daftar Kode Surat Prodi"
          onCancel={this.hideProdiModal}
          footer={null}
        >
          <List
            size="large"
            dataSource={this.state.prodiCodes}
            renderItem={(item, index) => (
              <List.Item key={index}>
                <Row>
                  <Col span={24}>
                    {item.name} - {item.level}
                  </Col>

                  <Col span={24}>
                    <Row gutter={[8, 8]}>
                      <Col>
                        {this.state.editMajor.find(
                          (ed) => ed.index === index
                        ) ? (
                          <Col>
                            <Row gutter={[8, 8]}>
                              <Col>
                                <span>
                                  no_surat/
                                  <Input
                                    onChange={(e) =>
                                      this.handleChangeNumberMajor(
                                        index,
                                        "unit_code",
                                        e.target.value
                                      )
                                    }
                                    style={{ width: 80 }}
                                    value={item?.letter_code?.unit_code}
                                  />
                                  /
                                  <Input
                                    onChange={(e) =>
                                      this.handleChangeNumberMajor(
                                        index,
                                        "letter_type_code",
                                        e.target.value
                                      )
                                    }
                                    style={{ width: 50 }}
                                    value={item?.letter_code?.letter_type_code}
                                  />
                                  /tahun
                                </span>
                              </Col>
                              <Col>
                                <Tooltip title="Simpan Kode Surat">
                                  <Button
                                    type="primary"
                                    size="small"
                                    icon={<SaveOutlined />}
                                    onClick={() =>
                                      this.handleSaveMajor(
                                        index,
                                        item.letter_id
                                      )
                                    }
                                  />
                                </Tooltip>
                              </Col>
                              <Col>
                                <Tooltip title="Batal">
                                  <Button
                                    type="danger"
                                    size="small"
                                    icon={<CloseOutlined />}
                                    onClick={() =>
                                      this.handleEditMajor(
                                        item._id,
                                        item.letter_id
                                      )
                                    }
                                  />
                                </Tooltip>
                              </Col>
                            </Row>
                          </Col>
                        ) : (
                          <Col>
                            <Row gutter={[8, 8]}>
                              <Col>
                                <span>
                                  no_surat/
                                  <strong>
                                    {item?.letter_code?.unit_code ?? "__"}
                                  </strong>
                                  /
                                  <strong>
                                    {item?.letter_code?.letter_type_code ??
                                      "__"}
                                  </strong>
                                  /tahun
                                </span>
                              </Col>
                              {["admin", "operator"].includes(
                                this.props.user.info.type
                              ) ? (
                                <Col>
                                  <Tooltip title="Update Kode Surat">
                                    <Button
                                      type="primary"
                                      size="small"
                                      icon={<EditOutlined />}
                                      onClick={() =>
                                        this.handleEditMajor(
                                          item._id,
                                          item.letter_id,
                                          index
                                        )
                                      }
                                    />
                                  </Tooltip>
                                </Col>
                              ) : null}
                            </Row>
                          </Col>
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </List.Item>
            )}
          />
        </Modal>
      </div>
    );
  }
}

export default withErrorHandler(LetterCodePage, Axios);
